module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/page-three-sub-one.ee26d082.jpg";